import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";
import PageShell from "@/components/PageShell";

const NotFound = () => {
  const { lang } = useLanguage();
  return (
    <PageShell dataTestId="not-found-page">
      <section className="max-w-[1400px] mx-auto px-6 md:px-12 py-32 text-center">
        <p className="overline kw-accent-line">404</p>
        <h1 className="mt-6 font-serif-display text-6xl md:text-8xl">
          {lang === "fr" ? "Page introuvable." : "Page not found."}
        </h1>
        <p className="mt-6 text-[#A19E9C]">
          {lang === "fr"
            ? "Le cliché que vous cherchez n'est pas au laboratoire."
            : "The frame you're looking for is not in the lab."}
        </p>
        <div className="mt-10">
          <Link to="/" className="kw-btn-primary">
            {lang === "fr" ? "Retour à l'accueil" : "Back home"}
          </Link>
        </div>
      </section>
    </PageShell>
  );
};

export default NotFound;
